import React, { useContext, useState, useEffect } from 'react';
import { Button, Form, Input, AutoComplete } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { MultiStepFormData } from '../../Authentication/MultiStepForm/MultiStepForm';
import { useSelector } from 'react-redux';
import { validationContent } from '../../../constants/Validation';
import { PlaceholderContent } from '../../../constants/Placeholder';

const AboutBusiness = () => {
  let content = validationContent?.SIGNUP_STEPS;
  let placeholderContent = PlaceholderContent?.BILLING_ADDRESS;
  const FormData = useContext(MultiStepFormData);
  const [isInitialized, setIsInitialized] = useState(false);
  const [data, setData] = useState({
    contactPerson: '',
    contactNumber: '',
    businessAddress: '',
    pincode: '',
    state: 'Kerala'
  });
  const [phone, setPhone] = useState();
  const info = useSelector(state => state.BusinessInfoReducer?.businessInfo)
  const businessAddressFromRedux = useSelector(state => state.BusinessInfoReducer?.businessInfo?.old_business_address);
  const businessPhoneFromRedux = useSelector((state) => state.Login?.user?.phoneNumber);
  useEffect(() => {
    let userDetails = localStorage.getItem('userDetails');
    if (userDetails) {
      let parsedData = JSON.parse(userDetails);
      const localPhone = parsedData.phone;
      setPhone(localPhone);  // This will only run once when the component mounts
    } else {
      console.log('No user details found in localStorage.');
    }
  }, []);

  // const businessNameFromRedux = useSelector(state => state.BusinessInfoReducer?.businessInfo?.business_name);
  const [businessAddress, setBusinessAddress] = useState(businessAddressFromRedux);
  const [autoCompleteOptions, setAutoCompleteOptions] = useState([]);
  const [businessAddressLength, setBusinessAddressLength] = useState(0);
  const businessDescriptionMaxLength = 200;

  const onChange = (value, fieldName) => {
    let content = value;
    if (fieldName === 'businessAddress') {
      setBusinessAddressLength(value?.length)
    }
    const updatedFormData = { ...FormData.formData };
    updatedFormData[fieldName] = value;
    FormData.setFormData(updatedFormData);

    setData(prevData => ({
      ...prevData,
      [fieldName]: value,
    }));
  };
  useEffect(() => {
    if (info) {
      setData({
        businessAddress: info?.old_business_address,
        contactNumber: phone || '',
        pincode: info?.pincode || '',
        state: info?.state || 'Kerala'
      })
    }
  }, [info , phone])
  const onSearch = (searchText) => {
    // Replace with actual logic to fetch or filter options
    const options = searchText ? [
      { value: '123 Main St' },
      { value: '456 Elm St' },
      { value: '789 Maple Ave' },
    ].filter(option => option.value.toLowerCase().includes(searchText.toLowerCase())) : [];
    setAutoCompleteOptions(options);
  };

  const allValuesNotEmpty = obj => Object.values(obj).every(value => value?.trim().length >= 2);
  const onFinish = (values) => {
    console.log('Success:', values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  useEffect(() => {
    const isContactNumberValid = data.contactNumber?.match(/^[0-9]{10}$/);
    const isDataValid = allValuesNotEmpty(data) && isContactNumberValid;

    if (isDataValid && data.pincode?.length === 6) {
      FormData.setFormVerified({
        ...FormData.formVerified,
        [FormData.page]: true
      });
    } else {
      FormData.setFormVerified({
        ...FormData.formVerified,
        [FormData.page]: false
      });
    }
  }, [data]);


  useEffect(() => {
    
    if (!isInitialized && FormData?.formData?.contactNumber) {
      setData((prev) => ({
        ...prev,
        contactNumber: FormData.formData.contactNumber,
      }));
      setIsInitialized(true);
    }
    FormData.setSkipButtonVisible(true)
  }, [FormData, isInitialized]);

  useEffect(() => {
    onChange(phone, 'contactNumber')
  }, [phone])

  useEffect(() => {
    if (data?.businessAddress) {
      setBusinessAddressLength(data?.businessAddress?.length)
    }
  }, [data?.businessAddress])

  useEffect(() => {
    if (businessAddressFromRedux) {
      setBusinessAddress(businessAddressFromRedux);
    }

  }, [businessAddressFromRedux]);

  return (
    <div style={{ width: '100%', marginLeft: 'auto', marginRight: 'auto' }} className="text-center about_business">
      <Form
        initialValues={{
          contactNumber: data.contactNumber || undefined,
          businessAddress: data.businessAddress || undefined,
          pincode: data.pincode || undefined,
          state: 'Kerala'
        }}
        className="form_body text-start"
        style={{ paddingBottom: 'calc(20px + 1vh)' }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <div style={{ maxWidth: '509px', marginLeft: 'auto', marginRight: 'auto' }}>
          <div className="cnt description_wrap">
            <label htmlFor="" className="text_red sm d-block text-start placeholder_left" >Business Address</label>
            <div style={{ display: 'flex', flexDirection: 'column', height: '100%', paddingBottom: '8px' }}>
              <Form.Item
                style={{ marginBottom: 0 }}
                rules={[
                  {
                    required: true,
                    message: content?.EnterBusinessAddress,
                  }
                ]}
              >
                <AutoComplete
                  options={autoCompleteOptions}
                  onSearch={onSearch}
                  onSelect={(value) => onChange(value, 'businessAddress')}
                  onChange={(value) => onChange(value, 'businessAddress')}
                  style={{ width: '100%' }}
                  value={data?.businessAddress}
                  maxLength={200}
                >
                  <TextArea
                    placeholder={placeholderContent?.Address}
                    className="custom input_field no-resize"
                    style={{ margin: '10px auto' }}

                  />
                </AutoComplete>
              </Form.Item>
            </div>
            <div className="">
              <span class={` form_note ${businessAddressLength === businessDescriptionMaxLength && 'limit'}`} ><span>{businessAddressLength}</span>/{businessDescriptionMaxLength}</span>
            </div>
          </div>
          <div className="wrap">
            <div className="cnt" style={{ paddingBottom: '8px' }}>
              <label htmlFor="" className="text_red d-block text-start sm placeholder_left" >State</label>
              <Form.Item
                style={{ marginBottom: 0 }}
                name="state"
                rules={[
                  {
                    required: true,
                    message: content?.SelectState,
                  }
                ]}
              >
                <Input
                  maxLength={50}
                  minLength={2}
                  className='input_field'
                  placeholder={placeholderContent?.State}
                  style={{ margin: '10px auto', color: '#9E9E9E', boxShadow: 'none', outline: 'none', height: 'calc(1vw + 38px)' }}
                  type="text"
                  onChange={(e) => onChange(e.target.value, 'state')}
                  disabled={true}
                />
              </Form.Item>
            </div>
            <div className="cnt" style={{ paddingBottom: '8px' }}>
              <label htmlFor="" className="text_red d-block text-start sm placeholder_left" >Pin Code</label>
              <Form.Item
                style={{ marginBottom: 0 }}
                name="pincode"
                rules={[
                  {
                    required: true,
                    message: content?.InvalidPIN,
                  }
                ]}
              >
                <Input
                  maxLength={6}
                  className='input_field text_transform_normal'
                  placeholder={placeholderContent?.PinCode}
                  onKeyPress={(e) => {
                    if (!/^\d$/.test(e.key)) {
                      e.preventDefault();  // Prevent typing non-digit characters
                    }
                  }}
                  onChange={(e) => onChange(e.target.value, 'pincode')}
                />
              </Form.Item>
            </div>
          </div>
          <div className="cnt text-left  contact_num">
            <label htmlFor="" className="text_red d-bloc sm text-start placeholder_left" >Contact Number</label>
            <div className="country_code_wrap">
              <span className='country_code'>+91</span>
              <Form.Item
                rules={[
                  {
                    required: true,
                    message: 'Please enter your Contact Number',
                  },
                  {
                    pattern: /^[0-9]{10}$/,
                    message: 'Please enter a valid 10-digit Contact Number',
                  },
                ]}
              >
                <Input
                  // disabled={phone}
                  disabled={true}
                  className='input_field'
                  placeholder=" 999 56 57 XXXX"
                  style={{ margin: '10px auto', color: '#9E9E9E', boxShadow: 'none', outline: 'none', height: 'calc(1vw + 38px)' }}
                  type="text"
                  maxLength={10}
                  onChange={(e) => onChange(e.target.value, 'contactNumber')}
                  onKeyDown={(e) => {
                    if (!(e.key === 'Backspace' || e.key === 'Delete' || /^\d$/.test(e.key))) {
                      e.preventDefault();
                    }
                  }}
                  value={data?.contactNumber}
                />
              </Form.Item>
            </div>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default AboutBusiness;
